module.exports = {
      id: "ic-countdown-light-active-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-countdown-light-active-usage",
      toString: function () {
        return this.url;
      }
    }